export const IP_ADDRESS_DATAS = "IpAddressDatas/success";
export const LOADING_IP_ADDRESS_DATAS = "IpAddressDatas/loading";
